import React from 'react';
import styled from 'styled-components';
import {
  ButtonTertiary,
  IconChevronLeft,
  PopoverNavigationItem,
  cssColorValue,
  semanticColors,
} from '@spotify-internal/encore-web/core';

import { MastheadLinkList } from 'lib/sanity/types';
import { isLinkDisabled, isLinkVisible } from 'components/Masthead/shared/utils';
import { NavBarPopoverList, NavBarPopoverListTitle } from 'components/Masthead/Header/Popover/Shared';
import { NavBarPopoverListItem } from 'components/Masthead/Header/Popover/LinkItem';

interface Props {
  closeBackdrop: () => void;
  closeSubMenu: () => void;
  isLoggedIn: boolean;
  subMenu: MastheadLinkList;
}

const StyledPopoverNavigationItem = styled(PopoverNavigationItem)`
  background-color: ${cssColorValue(semanticColors.backgroundTintedBase)};
  border-radius: 8px;
  padding: 8px 12px;
`;

const NavBarPopoverListTitleWrapper = styled.div`
  align-items: center;
  display: flex;
  gap: 16px;
`;

const BackButton = styled(ButtonTertiary)`
  padding: 0;
  min-block-size: 16px;
`;

export const SideMenuWithProfileLinksSubNavList = ({
  closeBackdrop,
  closeSubMenu,
  isLoggedIn,
  subMenu: { label, entries },
}: Props) => {
  const visibleLinks = entries.filter(({ link }) => isLinkVisible(link, isLoggedIn));
  return (
    <StyledPopoverNavigationItem>
      <NavBarPopoverListTitleWrapper>
        <BackButton aria-label="Arrow left" iconOnly={() => <IconChevronLeft size="small" />} onClick={closeSubMenu} />
        <NavBarPopoverListTitle>{label}</NavBarPopoverListTitle>
      </NavBarPopoverListTitleWrapper>
      <NavBarPopoverList>
        {visibleLinks.map(({ link, nestingLevel }, i) => (
          <NavBarPopoverListItem
            key={i}
            {...link}
            nestingLevel={nestingLevel}
            isDisabled={isLinkDisabled(link, isLoggedIn)}
            onClick={closeBackdrop}
          />
        ))}
      </NavBarPopoverList>
    </StyledPopoverNavigationItem>
  );
};
